import { render, staticRenderFns } from "./assistant_teacher_bar.vue?vue&type=template&id=3021e227&"
import script from "./assistant_teacher_bar.vue?vue&type=script&lang=js&"
export * from "./assistant_teacher_bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports